import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { updateFurtherDetails, UPDATE_FURTHER_DETAILS} from "../../actions/student.action"

function* handleUpdateFurtherDetails(action) {
  try {
    const { data : resData} = yield call(studentAPI.updateFurtherDetails, action.payload);
    //extract the data here     
    yield put(updateFurtherDetails.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(updateFurtherDetails.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* updateFurtherDetailsSaga() {
  yield takeLatest(UPDATE_FURTHER_DETAILS.REQUEST, handleUpdateFurtherDetails);
}

export default updateFurtherDetailsSaga;
